const RECRUIT_SITE_URL = 'https://sp-thanks.com/recruit/';

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-[#060148] px-5 py-14 sm:px-8 sm:py-16">
      <span
        aria-hidden="true"
        className="absolute right-[-2rem] top-8 h-28 w-28 opacity-20"
        style={{
          background: '#E85B63',
          clipPath: 'polygon(50% 0, 0 100%, 100% 100%)',
        }}
      />
      <span
        aria-hidden="true"
        className="absolute bottom-[-2.5rem] left-6 h-32 w-32 opacity-15"
        style={{
          background: '#FFFFFF',
          clipPath: 'polygon(0 0, 100% 100%, 0 100%)',
        }}
      />

      <div className="relative z-10 mx-auto flex max-w-4xl flex-col items-center text-center">
        <p className="max-w-2xl text-[18px] font-medium leading-[1.8] text-white/90 sm:text-[20px]">
          気になることを整理できたら、募集情報や働く人のことも見に行けます。
        </p>

        <a
          href={RECRUIT_SITE_URL}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="font-cta mt-7 inline-flex min-h-[56px] items-center justify-center rounded-lg bg-[#E85B63] px-7 py-3 text-[18px] text-white transition-colors duration-200 hover:bg-[#d94e57] sm:text-[20px]"
        >
          採用サイトに戻る →
        </a>

        <p className="font-latin mt-8 text-[14px] font-medium text-white/60">&copy; 2025 Special Thanks Inc.</p>
      </div>
    </footer>
  );
}
